import styled from 'src/styles/theme';
import { ModalFeatureDetailStyled } from '../ModalFeatureDetailStyled';
import { rem } from 'polished';

export const ModalFeatureDetailStyledDS = styled(ModalFeatureDetailStyled)`
    
`;
